import Http from "../http";

class OfferServices {
    static async getAllOffers() {
        console.log('=================================================================i am in the userservices', )
        return Http.get('/getOffers');
      }
      static async createOffers(data){
        return Http.post('/createNewOffers',data)
      }
     static async updateOffer(id,data){
        return Http.update(`/offers/${id}`,data)
     }
     static async deleteOffer(id){
        return Http.delete(`/offers/${id}`)
     }
}
export default OfferServices;